<template>
  <div class="title">
    {{ title }}
  </div>
</template>

<script>
export default {
  props: ["title"],
  methods: {},
};
</script>

<style lang="scss" scoped>
.title {
  @include ft(44);
  // @include mb(20);
  @include lh(74);
  // @include pd(20, 0);
  @include wh(750, 95);
  color: rgba(255, 212, 137, 1);
  @include vc;
  font-family: Arial;
  font-weight: bold;
  background: #000000;
  border-bottom: 1px solid rgba(133, 116, 87, 1);
}
</style>